import { render, staticRenderFns } from "./OrderCalendarView.vue?vue&type=template&id=4ca59088&scoped=true&lang=pug&"
import script from "./OrderCalendarView.vue?vue&type=script&lang=js&"
export * from "./OrderCalendarView.vue?vue&type=script&lang=js&"
import style0 from "./OrderCalendarView.vue?vue&type=style&index=0&id=4ca59088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca59088",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDivider,VImg,VLayout,VProgressCircular,VRow})
